import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

type CartIntermediateContinueShoppingButtonProps = {
  onClick: () => void
}

export const CartIntermediateContinueShoppingButton: FC<
  CartIntermediateContinueShoppingButtonProps
> = ({ onClick }) => {
  return (
    <Button
      className="w-full"
      data-qa-id="continue-shopping-button"
      onClick={onClick}
      variant="outlined"
    >
      <FormattedMessage id="general.link.label.continueShopping" />
    </Button>
  )
}
